












import {Component, Prop, Vue} from 'vue-property-decorator';
import Loading from '../assets/loading.svg';

@Component({
	components: {
		Loading
	}
})
export default class LoadingOverlay extends Vue {

}
